import { render, staticRenderFns } from "./AsfFormBuilder.vue?vue&type=template&id=9ea25076&scoped=true"
import script from "./AsfFormBuilder.vue?vue&type=script&lang=js"
export * from "./AsfFormBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea25076",
  null
  
)

export default component.exports